import React from 'react';
import styled from 'styled-components';
import { breakpoint, theme } from '../../theme';
import { BodyText, Heading } from '../typography';

export type ContentfulHeadingProps = {
  heading: string | number;
  subHeading: string | number;
};
const HeadingContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${theme.spacings[2].rem};
`;
const ContentHeading = styled(Heading).attrs({ size: 3 })`
  font-family: ${theme.fonts.heading} !important;
  ${breakpoint('sm')`
      ${theme.typography.headings[2]['sm-lg']}
    `};
`;
const SubHeading = styled(BodyText).attrs({ size: { xs: 'md', sm: 'lg' } })``;

export const ContentfulHeading: React.FC<ContentfulHeadingProps> = (data) => {
  return (
    <HeadingContainer>
      <ContentHeading> {data?.heading}</ContentHeading>
      <SubHeading>{data?.subHeading}</SubHeading>
    </HeadingContainer>
  );
};
